import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { CellRadio } from '../Cell';

const ExtendPackageItem = ({
  title,
  value,
  checkedId,
  expiredDays,
  devNum,
  supportedDevNum,
  onSelected,
}: {
  title: string;
  value: string;
  checkedId?: string;
  expiredDays: number;
  devNum: number;
  supportedDevNum: number;
  onSelected: () => void;
}) => {
  const { t } = useTranslation();

  const handleSelected = useCallback(() => {
    if (value !== checkedId) {
      onSelected();
    }
  }, [checkedId, value, onSelected]);

  const Desc = (
    <>
      <div className="price-list">
        <span className="day">
          {expiredDays}
          {t('days_left')}
        </span>
      </div>
      <p className="desc">
        {`${devNum}/${supportedDevNum} `}
        {t('device')}
      </p>
    </>
  );

  return (
    <CellRadio
      inner
      title={title}
      value={value}
      onClick={handleSelected}
      checked={checkedId === value}
      description={Desc}
      className="gift-card-package-item"
    />
  );
};

export default ExtendPackageItem;
